export var Context;
(function(Context) {
    Context["SQUAD"] = "A&E";
    Context["HERO_USP"] = "Hero - USP";
    Context["HERO_TRUSTPILOT"] = "Hero - Trustpilot";
    Context["HERO_SEARCH"] = "Hero - Search";
    Context["CAR_REVIEW"] = "Car Review";
})(Context || (Context = {}));
